import { GLOSSARYDATA } from '../../constants/reducerTypes';

const initialState = [];
const glossaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GLOSSARYDATA:
            return action.payload;
        default:
            return state;
    }
};
export default glossaryReducer;
